import { FieldProps } from "formik";
import React from "react";
import ReactSelect, { Props as ReactSelectProps } from "react-select";
import AsyncSelect from "react-select/async";

export interface OptionType {
	value: string;
	label: string;
	isDisabled?: boolean;
}
export interface OptionGroupedType {
	label: string;
	options: OptionType[];
	isSquare?: boolean;
}

export interface SelectProps extends ReactSelectProps {
	data?: OptionType[];
	groupedData?: OptionGroupedType[];
	field?: FieldProps["field"];
	form?: FieldProps["form"];
	name: string;
	onChange?: (e: any) => void;
	selectValue?: string;
	value?: OptionType;
	className?: string;
	disabled?: boolean;
	loadOptionsAsync?: (inputValue: string, callback: (data: OptionType[]) => void) => void;
	isSearchable?: boolean;
}

const Select: React.FC<SelectProps> = ({
	data = [],
	groupedData,
	field,
	form,
	id,
	name,
	onChange,
	selectValue,
	value,
	className,
	disabled,
	loadOptionsAsync,
	isSearchable = true,
	...props
}) => {
	const realValue = groupedData
		? groupedData
				.find((group: OptionGroupedType) => {
					const v = field?.value || value;
					const blah = group.options?.find((o: OptionType) => {
						return o.value === v;
					});
					if (blah) {
						return blah;
					}
				})
				?.options.find((o: OptionType) => {
					const v = field?.value === false ? false : field?.value ?? value;
					return o.value === v;
				})
		: data.find((o) => {
				const v = field?.value === false ? false : field?.value ?? value;
				return o.value === v;
		  });

	const realName = field?.name || name;

	if (form?.status?.bag?.readonly) {
		return <div className="form-readonly-value">{realValue?.label}</div>;
	}

	if (loadOptionsAsync) {
		return (
			<>
				<AsyncSelect
					loadOptions={loadOptionsAsync}
					options={groupedData || data}
					{...field}
					name={realName}
					value={realValue !== undefined ? realValue : null}
					onBlur={() => {
						form?.setFieldTouched(realName, true);
					}}
					onChange={(option: any) => {
						form?.setFieldValue(realName, option?.value);
						if (onChange) {
							onChange(option);
						}
					}}
					inputId={id}
					isDisabled={disabled}
					{...props}
					className={`react-select-container ${className}`}
					classNamePrefix="react-select"
					isClearable={props.isClearable ?? true}
					menuPlacement="auto"
					onMenuOpen={() => {
						form?.setStatus({ ...form.status, menuOpen: true });
					}}
					onMenuClose={() => {
						form?.setStatus({ ...form.status, menuOpen: false });
					}}
				/>
			</>
		);
	}

	return (
		<>
			<ReactSelect
				options={groupedData || data}
				{...field}
				name={realName}
				value={realValue !== undefined ? realValue : null}
				onBlur={() => {
					form?.setFieldTouched(realName, true);
				}}
				onChange={(option: any) => {
					form?.setFieldValue(realName, option?.value);
					if (onChange) {
						onChange(option);
					}
				}}
				inputId={id}
				isDisabled={disabled}
				isSearchable={isSearchable}
				{...props}
				className={`react-select-container ${className}`}
				classNamePrefix="react-select"
				isClearable={props.isClearable ?? true}
				//menuPlacement="auto"
				onMenuOpen={() => {
					form?.setStatus({ ...form.status, menuOpen: true });
				}}
				onMenuClose={() => {
					form?.setStatus({ ...form.status, menuOpen: false });
				}}
				//isDisabled isn't a part of the react-select type definition
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				//@ts-ignore
				isOptionDisabled={(option) => option?.isDisabled}
			/>
		</>
	);
};

export default Select;
